import { BeforeNotifyHandler } from '@honeybadger-io/core/build/src/types';
import isString from 'lodash-es/isString';

import { ApiValidationError, Http } from '@catawiki/runtime-toolkit';

export const ignoreProtocols: string[] = [
  'chrome-extension:',
  'moz-extension:',
  'safari-extension:',
  'file:',
  'unknown',
];

// Ignore errors that are not actionable
const ignoreErrors: (string | RegExp)[] = [
  /Failed to fetch$/,
  /Load failed$/,
  // ignore avast antivirus extension error
  /_avast_submit/,
  // ignore hackLocationFailed error
  /hackLocationFailed/,
  // ignore fetch errors when user has no connection or opens a page saved locally as HTML
  /failed with status code 0$/,
];

export const isRelevantError: BeforeNotifyHandler = (notice) => {
  // Ignore errors from chrome extensions and local files
  if (
    ignoreProtocols.some(
      (protocol) =>
        notice?.url?.startsWith(protocol) ||
        notice?.backtrace?.some((frame) => frame.file.startsWith(protocol))
    )
  ) {
    return false;
  }

  const fetchResponseError = notice?.context
    .error as Http.HttpResponseException<ApiValidationError>;

  const fetchResponseErrorMessage = fetchResponseError?.message || '';
  const fetchValidationErrorMessage =
    fetchResponseError?.payload?.message || '';
  const contextMessage = notice?.context.message || '';
  const errorMessage = notice?.message || '';

  // Collect all possible sources of error messages from known errors
  const possibleNoticeMessages = [
    fetchResponseErrorMessage,
    fetchValidationErrorMessage,
    contextMessage,
    errorMessage,
  ];

  // Ignore errors that are not actionable
  return !ignoreErrors.some((errorToIgnore) =>
    possibleNoticeMessages.some((message) => {
      if (isString(message)) {
        return errorToIgnore instanceof RegExp
          ? errorToIgnore.test(message)
          : message.includes(errorToIgnore);
      }

      return false;
    })
  );
};
